/**
 * 通知路由配置
 * 定义哪些路由显示 Notification 组件，哪些不显示
 */

import { ROUTER_PATH } from "./router";

interface NotificationRouteConfig {
  /** 显示 Notification 的路由列表 */
  showNotification: string[];
  /** 不显示 Notification 的路由列表(可能有自定义处理) */
  hideNotification: string[];
  /** 默认行为: 'show' | 'hide' */
  defaultBehavior: "show" | "hide";
}

/**
 * 通知路由配置
 *
 * @example
 * // 显示 Notification 的路由
 * showNotification: ['/dashboard', '/settings']
 *
 * // 不显示 Notification 的路由(通常这些路由会注册自定义处理器)
 * hideNotification: ['/timeline', '/reports']
 */
const notificationRouteConfig: NotificationRouteConfig = {
  // 显示 Notification 的路由 defaultBehavior为show时可以为空
  showNotification: [],

  // 不显示 Notification 的路由(可能有自定义处理)
  hideNotification: [ROUTER_PATH.SETTING, ROUTER_PATH.MEMBER],

  // 默认行为: 当路由不在上述列表中时的行为
  defaultBehavior: "show",
};

/**
 * 检查当前路由是否应该显示 Notification
 * @param pathname 当前路由路径
 * @returns 是否显示 Notification
 */
export const shouldShowNotification = (pathname: string): boolean => {
  // 检查是否在显式配置的显示列表中
  if (
    notificationRouteConfig.showNotification.some((route) => {
      if (pathname?.startsWith(route)) {
        return true;
      }
      const pathArray = pathname?.split("/");
      if (
        pathArray?.length >= 2 &&
        pathArray?.[2] === route?.split?.("/")?.[1]
      ) {
        return true;
      }
    })
  ) {
    return true;
  }

  // 检查是否在显式配置的隐藏列表中
  if (
    notificationRouteConfig.hideNotification.some((route) => {
      if (pathname?.startsWith(route)) {
        return true;
      }
      const pathArray = pathname?.split("/");

      if (
        pathArray?.length >= 2 &&
        pathArray?.[2] === route?.split?.("/")?.[1]
      ) {
        return true;
      }
      return false;
    })
  ) {
    return false;
  }

  // 返回默认行为
  return notificationRouteConfig.defaultBehavior === "show";
};

/**
 * ACCOUNT_READ 深链路由模板（fe-spec §3.4 / Slice 8 契约同源）
 * push payload: { type: "ACCOUNT_READ", report_id, side }
 */
export const ACCOUNT_READ_REPORT_ROUTE = (reportId: string) =>
  `/brief/report?entry=push&start=${encodeURIComponent(reportId)}&skipOpening=1`;
